import React, { useCallback } from 'react'

import S from './styled'

const Tag = ({ title, valueId, onClick, selected, disabled }) => (
  <S.TagContainer onClick={disabled ? null : () => onClick(valueId)}>
    <S.Tag key={`tag_${valueId}`} selected={selected}>{title}</S.Tag>
  </S.TagContainer>
)

const Switch = ({ title, name, value = '', values, onChange, disabled }) => {

  const handleClick = useCallback(id => {
    onChange({
      target: {
        name, value: id,
      },
    })
  }, [name, onChange])

  return (
    <S.TagsContainer className={disabled ? 'disabled' : ''}>
      {title && <label>{title}</label>}
      <S.Tags>
        {
          Reflect.ownKeys(values).map(item => {
            const checked = value === item
            return (
              <Tag
                key={`tag_${item}`}
                title={values[item].name}
                valueId={item}
                onClick={handleClick}
                selected={checked}
                disabled={disabled}
              />
            )
          })
        }
      </S.Tags>
    </S.TagsContainer>
  )
}

export default Switch
